import { Star, ArrowRight } from 'lucide-react';
import LeadForm from '../LeadForm';

export default function HeroSection({ isCity, cityName, cityData }) {
  return (
    <section className="bg-white border-b border-gray-200" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7 animate-fade-in-up">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#E3000F] mb-4 font-['IBM_Plex_Sans']">
              {"Déclaration d'impôt 2025 "}{isCity ? `— ${cityName}` : '— Suisse Romande'}
            </p>
            <h1 className="font-['Chivo'] font-black text-4xl sm:text-5xl lg:text-6xl text-[#111827] tracking-tight leading-none mb-6">
              {isCity
                ? `Votre déclaration d'impôt à ${cityName}, sans erreurs.`
                : "Chaque erreur dans votre déclaration vous coûte de l'argent."
              }
            </h1>
            <p className="text-base sm:text-lg text-gray-600 font-['IBM_Plex_Sans'] leading-relaxed mb-8 max-w-2xl">
              {isCity
                ? `${cityData.taxSpecific} Confiez votre déclaration à un expert fiscal certifié à ${cityName} et récupérez chaque franc qui vous est dû.`
                : "93% des contribuables suisses paient plus d'impôts que nécessaire. Un expert fiscal certifié analyse votre situation, identifie toutes les déductions légales et soumet votre déclaration sans erreur — pour que vous gardiez ce qui vous appartient."
              }
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8">
              <div className="flex items-center gap-1">
                {[1,2,3,4,5].map((n) => <Star key={`hero-star-${n}`} size={18} className="fill-[#E3000F] text-[#E3000F]" />)}
              </div>
              <span className="text-sm font-semibold text-gray-700 font-['IBM_Plex_Sans']">
                {"Plus de 98'000 clients satisfaits en Suisse"}
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href="#formulaire" className="bg-[#E3000F] text-white hover:bg-[#A6000B] px-8 py-4 font-bold text-base tracking-wide transition-colors font-['IBM_Plex_Sans'] text-center inline-flex items-center justify-center gap-2" data-testid="hero-cta">
                Trouver mon expert fiscal <ArrowRight size={18} />
              </a>
              <a href="#avantages" className="border-2 border-[#111827] text-[#111827] hover:bg-gray-100 px-8 py-4 font-bold text-base tracking-wide transition-colors font-['IBM_Plex_Sans'] text-center" data-testid="hero-secondary-cta">
                En savoir plus
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 animate-fade-in-up animate-delay-200" id="formulaire">
            <div className="border border-gray-200 bg-[#F9FAFB] p-6 sm:p-8" data-testid="hero-form-container">
              <h2 className="font-['Chivo'] font-bold text-xl sm:text-2xl text-[#111827] mb-1">Devis gratuit et sans engagement</h2>
              <p className="text-sm text-gray-500 mb-6 font-['IBM_Plex_Sans']">Un expert fiscal de votre région vous contacte sous 24h</p>
              <LeadForm city={cityName} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
